export default "__VITE_ASSET__846a0096__"